import { makeAutoObservable } from 'mobx';
import { LeaderboardUserDto } from '../../../../defs/api';

export class LeaderboardUserMobxDto implements LeaderboardUserDto {
    value: number;

    id: string;

    fullName: string;

    position: number;

    constructor() {
        makeAutoObservable(this);
    }

    static create(dto: LeaderboardUserDto): LeaderboardUserMobxDto {
        const mobxDto = new LeaderboardUserMobxDto();
        return Object.assign(mobxDto, dto);
    }

    static createFromArray(dtos: LeaderboardUserDto[]): LeaderboardUserMobxDto[] {
        return dtos.map((dto) => LeaderboardUserMobxDto.create(dto));
    }
}
